/**
 * 简单版 HTML 净化器（无需 DOMPurify 依赖）
 * 通过白名单过滤危险标签和属性，防止 XSS 攻击
 */

const ALLOWED_TAGS = new Set([
    'p', 'br', 'b', 'i', 'u', 'strong', 'em', 'ul', 'ol', 'li',
    'span', 'div', 'h1', 'h2', 'h3', 'h4', 'table', 'tr', 'td', 'th',
    'thead', 'tbody', 'img', 'a', 'style', 'font'
])

const ALLOWED_ATTRS = new Set([
    'style', 'class', 'src', 'alt', 'width', 'height', 'href', 'target',
    'color', 'size', 'face', 'border', 'cellpadding', 'cellspacing',
    'align', 'valign', 'colspan', 'rowspan'
])

/**
 * 净化 HTML 字符串
 * @param {string} html - 需要净化的 HTML
 * @returns {string} 净化后的安全 HTML
 */
export function sanitizeHtml(html) {
    if (!html) return ''
    if (typeof html !== 'string') return ''

    // 1. 移除 script 标签及其内容
    let result = html.replace(/<script[\s\S]*?<\/script>/gi, '')
    // 2. 移除残留的 script 开始/结束标签
    result = result.replace(/<\/?script[^>]*>/gi, '')
    // 3. 移除 javascript: 协议
    result = result.replace(/javascript\s*:/gi, '')
    // 3.5 过滤 style 属性中的危险 CSS
    result = result.replace(/style\s*=\s*(?:"([^"]*)"|'([^']*)')/gi, function(match, p1, p2) {
        const styleVal = p1 || p2 || ''
        if (/expression\s*\(|@import|url\s*\(/i.test(styleVal)) {
            return ''
        }
        return match
    })
    // 4. 移除事件属性 (on*)
    result = result.replace(/[\s/]on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/gi, '')
    // 5. 移除 data: 协议（可用于 XSS）
    result = result.replace(/data\s*:\s*text\/html/gi, '')
    // 6. 移除 v-bind 和 @ 事件绑定（Vue XSS）
    result = result.replace(/\s+(v-bind|v-on|@)\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/gi, '')
    // 7. 移除 iframe, object, embed, form 等危险标签
    result = result.replace(/<\/?\s*(iframe|object|embed|form|input|textarea|select|button|link|meta|base|applet)[^>]*>/gi, '')
    // 8. 移除不在白名单中的标签（保留内容）
    result = result.replace(/<\/?\s*([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/g, function(match, tagName) {
        const tag = tagName.toLowerCase()
        if (!ALLOWED_TAGS.has(tag)) {
            // 移除标签但保留内部文本
            return match.replace(/<\/?[^>]*>/g, '')
        }
        // 对白名单内的标签，过滤掉不允许的属性
        return match.replace(/\s+([a-zA-Z][\w-]*)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/g, function(attrMatch, attrName) {
            if (!ALLOWED_ATTRS.has(attrName.toLowerCase())) {
                return ''
            }
            return attrMatch
        })
    })

    return result
}
